import { render } from "./DataPrivacyView.vue?vue&type=template&id=30019aee&scoped=true&ts=true"
import script from "./DataPrivacyView.vue?vue&type=script&lang=ts"
export * from "./DataPrivacyView.vue?vue&type=script&lang=ts"

import "./DataPrivacyView.vue?vue&type=style&index=0&id=30019aee&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30019aee"]])

export default __exports__